import * as React from "react";
import { Stack, Card } from "@origin-digital/ods-core";
import { Formik, Form } from "formik";
import { RequestStatusEnum } from "src/components/Changes/types";
import ChangeRequestElectricityBlock from "./ChangeRequestElectricityBlock";
import ChangeRequestPremiseBlock from "./ChangeRequestPremiseBlock";
import ChangeRequestContext from "src/context/ChangeRequestContext";
import ChangeRequestPremiseBlockReadonly from "./ChangeRequestPremiseBlockReadonly";
import ChangeRequestElectricityBlockReadonly from "./ChangeRequestElectricityBlockReadonly";
import { ChangeRequestFormValues } from "./formValue";
import { useParams } from "react-router-dom";

interface ChangeRequestFormContentProps {
  formValues: ChangeRequestFormValues;
}

const ChangeRequestFormContent: React.FC<ChangeRequestFormContentProps> = ({
  formValues,
}) => {
  const { draftInfo } = React.useContext(ChangeRequestContext);
  const { requestId } = useParams<{ requestId: string }>();
  //three overall states: new, draft, submitted
  const isNew = draftInfo === null;
  const isDraft = draftInfo?.raw_request_status === RequestStatusEnum.DRAFT;
  const isSubmitted = !isNew && !isDraft;

  return (
    <Card outline>
      <Formik<ChangeRequestFormValues>
        initialValues={formValues}
        onSubmit={() => {}}
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize={true}
      >
        <Form>
          <Stack space={{ xs: "xlarge", md: "xxlarge" }}>
            {!requestId && isNew && <ChangeRequestPremiseBlock />}
            {(isDraft || isSubmitted) && (
              <ChangeRequestPremiseBlockReadonly
                isSubmitted={isSubmitted}
                isDraft={isDraft}
              />
            )}
            {isDraft && <ChangeRequestElectricityBlock />}
            {isSubmitted && <ChangeRequestElectricityBlockReadonly />}
          </Stack>
        </Form>
      </Formik>
    </Card>
  );
};

export default ChangeRequestFormContent;
